import fiatCurrencies from "./fiatCurrencies";

export function formatCurrency(
  value,
  currency,
  truncate = 2,
  hideCurrencySymbol = false,
  roundingMode = "floor",
  formatOptions = {},
) {
  const options = {
    minimumFractionDigits: truncate,
    maximumFractionDigits: truncate,
    roundingMode,
    ...formatOptions,
  };

  let fiatCode = null;
  let currencyCode = "";
  if (currency) {
    fiatCode = fiatCurrencies?.[currency.toUpperCase()];
    currencyCode = currency.toUpperCase();
    if (currencyCode === "USD") {
      options.style = "currency";
      options.currency = currencyCode;
      options.currencyDisplay = "symbol";
    }
  }
  // if (!fiatCode) {
  //   options.style = 'decimal'
  //   options.currencyDisplay = 'code'
  // }
  // if (Boolean(fiatCode) && !hideCurrencySymbol) {
  //   options.style = 'currency'
  //   options.currency = resCurrency
  //   options.currencyDisplay = 'symbol'
  // } else {
  // options.style = 'decimal'
  // options.currencyDisplay = "code"
  // }
  const formatter = new Intl.NumberFormat("en-US", options);
  let formattedValue = null;
  if (fiatCode) {
    currencyCode = fiatCode.code;
    formattedValue = `${formatter.format(value || "")}`;
    if (formattedValue.split(".")[1] === "00") {
      formattedValue = formattedValue.replace(".00", "");
    }
  } else {
    if (currency) {
      const arr = String(value).split(".");
      if (arr[1] && arr[1].length > 8) {
        formattedValue = `${value.toFixed(8)}`;
      } else {
        formattedValue = value;
      }
    } else {
      formattedValue = `${formatter.format(value || "")}`;
      formattedValue = formattedValue.replace(".00", "");
    }
  }

  if (hideCurrencySymbol || currencyCode === "USD") {
    currencyCode = "";
  }

  return `${formattedValue} ${currencyCode}`;
}

export default formatCurrency;

export function formatCrypto(value) {
  const formatter = new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 30,
  });

  return formatter.format(value);
}

export function toFixed(num, fixed) {
  return num
    .toString()
    .match(new RegExp("^-?\\d+(?:\\d{0," + (fixed || -1) + "})?"))[0];
}
